import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import moment from 'moment';
import api from '../../lib/api';
import AdminPageShell from '../../components/admin/AdminPageShell';

const STATUS_LABELS = { 0: 'Новая', 1: 'В работе', 2: 'Решена' };
const CONVERSATION_LABELS = { 0: 'Личный чат', 1: 'Чат встречи' };

const styles = (theme) => ({
  pageBody: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    overflowX: 'auto',
    maxWidth: '100%',
  },
  table: {
    minWidth: 700,
    '& thead th': { backgroundColor: '#f8f9fa', fontWeight: 600, fontSize: '0.875rem' },
    '& tbody td': { borderBottom: '1px solid #e9ecef', padding: theme.spacing(1.5) },
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  resolveBtn: {
    textTransform: 'none',
  },
  messageText: {
    maxWidth: 280,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

class ChatReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      reports: [],
      statusFilter: null,
      resolveDialog: null,
      resolveComment: '',
      resolveBanUser: false,
      resolveBannedUntil: '',
      submitting: false,
    };
  }

  componentDidMount() {
    this.loadReports();
  }

  loadReports = async () => {
    this.setState({ loading: true });
    try {
      const reports = await api.getChatReports(this.state.statusFilter);
      this.setState({ reports: reports || [], loading: false });
    } catch (err) {
      console.error('Ошибка загрузки жалоб на чат:', err);
      this.setState({ reports: [], loading: false });
    }
  };

  handleFilterChange = (e, value) => {
    const statusFilter = value === 'all' ? null : value;
    this.setState({ statusFilter }, () => this.loadReports());
  };

  openResolve = (report) => {
    this.setState({
      resolveDialog: report,
      resolveComment: '',
      resolveBanUser: false,
      resolveBannedUntil: '',
    });
  };

  closeResolve = () => {
    this.setState({ resolveDialog: null });
  };

  submitResolve = async () => {
    const { resolveDialog, resolveComment, resolveBanUser, resolveBannedUntil } = this.state;
    if (!resolveDialog) return;
    this.setState({ submitting: true });
    try {
      await api.resolveChatReport(resolveDialog.id, {
        resolvedComment: resolveComment,
        banUser: resolveBanUser,
        bannedUntil: resolveBannedUntil ? moment(resolveBannedUntil).toISOString() : null,
      });
      this.closeResolve();
      this.loadReports();
    } catch (err) {
      console.error('Ошибка при закрытии жалобы:', err);
    } finally {
      this.setState({ submitting: false });
    }
  };

  render() {
    const { classes } = this.props;
    const {
      loading,
      reports,
      statusFilter,
      resolveDialog,
      resolveComment,
      resolveBanUser,
      resolveBannedUntil,
      submitting,
    } = this.state;

    return (
      <AdminPageShell title="Жалобы на чат">
      <div className={classes.pageBody}>
        <Paper className={classes.paper}>
          <Tabs
            value={statusFilter === null ? 'all' : statusFilter}
            onChange={this.handleFilterChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Все" value="all" />
            <Tab label="Новые" value={0} />
            <Tab label="В работе" value={1} />
            <Tab label="Решённые" value={2} />
          </Tabs>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <Table className={classes.table} size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Дата</TableCell>
                  <TableCell>Кто пожаловался</TableCell>
                  <TableCell>На кого</TableCell>
                  <TableCell>Тип</TableCell>
                  <TableCell>Текст сообщения</TableCell>
                  <TableCell>Причина</TableCell>
                  <TableCell>Статус</TableCell>
                  <TableCell align="right">Действия</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reports.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" style={{ padding: 24 }}>
                      Нет жалоб
                    </TableCell>
                  </TableRow>
                ) : (
                  reports.map((r) => (
                    <TableRow key={r.id}>
                      <TableCell>{moment(r.createdAt).format('DD.MM.YYYY HH:mm')}</TableCell>
                      <TableCell>
                        {[r.reporterName, r.reporterPhone].filter(Boolean).join(' ') || `ID ${r.reporterUserId}`}
                      </TableCell>
                      <TableCell>
                        {[r.reportedName, r.reportedPhone].filter(Boolean).join(' ') || `ID ${r.reportedUserId}`}
                      </TableCell>
                      <TableCell>{CONVERSATION_LABELS[r.conversationType] ?? r.conversationType}</TableCell>
                      <TableCell className={classes.messageText} title={r.reportedMessageText}>
                        {r.reportedMessageText || '—'}
                      </TableCell>
                      <TableCell>{r.reason || '—'}</TableCell>
                      <TableCell>{STATUS_LABELS[r.status] ?? r.status}</TableCell>
                      <TableCell align="right">
                        {r.status !== 2 && (
                          <Button
                            size="small"
                            color="primary"
                            className={classes.resolveBtn}
                            onClick={() => this.openResolve(r)}
                          >
                            Разобрать
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}
        </Paper>

        <Dialog open={!!resolveDialog} onClose={this.closeResolve} maxWidth="sm" fullWidth>
          <DialogTitle>Закрыть жалобу</DialogTitle>
          <DialogContent>
            {resolveDialog && (
              <>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                  На кого: {resolveDialog.reportedName || resolveDialog.reportedPhone || `ID ${resolveDialog.reportedUserId}`}
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Комментарий модератора"
                  value={resolveComment}
                  onChange={(e) => this.setState({ resolveComment: e.target.value })}
                  variant="outlined"
                  margin="normal"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={resolveBanUser}
                      onChange={(e) => this.setState({ resolveBanUser: e.target.checked })}
                      color="primary"
                    />
                  }
                  label="Заблокировать пользователя (бан)"
                />
                {resolveBanUser && (
                  <TextField
                    fullWidth
                    type="date"
                    label="Срок бана до (необязательно)"
                    value={resolveBannedUntil}
                    onChange={(e) => this.setState({ resolveBannedUntil: e.target.value })}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    margin="normal"
                  />
                )}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeResolve}>Отмена</Button>
            <Button onClick={this.submitResolve} color="primary" disabled={submitting}>
              {submitting ? 'Сохранение…' : 'Закрыть жалобу'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      </AdminPageShell>
    );
  }
}

export default withStyles(styles)(ChatReports);
